import { render, staticRenderFns } from "./course.vue?vue&type=template&id=6a29f95b&scoped=true&"
import script from "./course.vue?vue&type=script&lang=ts&"
export * from "./course.vue?vue&type=script&lang=ts&"
import style0 from "./course.vue?vue&type=style&index=0&id=6a29f95b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29f95b",
  null
  
)

export default component.exports